import { LANGUAGE_CONFIG, getCurrentLanguage, switchLanguage } from '../utils/languageSwitcher';

const LanguageSwitcher = () => {
  const currentLanguage = getCurrentLanguage();
  const currentConfig = LANGUAGE_CONFIG[currentLanguage];

  const handleLanguageSwitch = (locale) => {
    switchLanguage(locale);
  };

  return (
    <div className="language-switcher">

      {Object.entries(LANGUAGE_CONFIG).map(([locale, config]) => (
      <div onClick={() => handleLanguageSwitch(locale)} className={`flag ${config.flag === currentConfig.flag && "flag-active"}`} key={locale}>
        <div><img src={"https://flagcdn.com/w320/" + config.flag + ".png"} alt={config.name+"Flag"}/></div>
        <h4>{config.flag}</h4>
      </div>
      ))}

      {/* 
      <button  className="language-switcher-button" onClick={() => setIsOpen(!isOpen)}>
        <span className="flag">{currentConfig.flag}</span>
        <span className="language-name">{currentConfig.name}</span>
        <span className="arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {Object.entries(LANGUAGE_CONFIG).map(([locale, config]) => (
            <button
              key={locale}
              className={`language-option ${locale === currentLanguage ? 'active' : ''}`}
              onClick={() => handleLanguageSwitch(locale)}
              disabled={locale === currentLanguage}
            >
              <span className="flag">{config.flag}</span>
              <span className="language-name">{config.name}</span>
            </button>
          ))}
        </div>
      )}
        */}
    </div>
  );
};

export default LanguageSwitcher;
